<template>
  <div>
    <div
      v-if="!edit"
      class="d-flex align-items-center"
    >
      <slot :value="value">
        {{ value }}
      </slot>
      <b-button
        v-if="enableEdit"
        variant="link"
        @click="showEdit()"
      >
        <font-awesome-icon
          icon="pen"
          class="mr-2"
        />
        <span class="playfare">Edit</span>
      </b-button>
    </div>
    <div
      v-else
      class="d-flex align-items-stretch"
    >
      <input
        ref="input"
        v-model="data"
        type="text"
        class="w-100"
        @keydown.enter="saveEdit()"
      >
      <div class="d-flex">
        <base-button
          inverse
          @click="saveEdit()"
        >
          <span class="text-nowrap playfare">Save</span>
        </base-button>
        <b-button
          variant="link"
          @click="cancelEdit()"
        >
          <span class="playfare">Cancel</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleEditable',
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    enableEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      edit: false,
      data: null,
    };
  },
  methods: {
    showEdit() {
      this.edit = true;
      this.data = this.value;
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    saveEdit() {
      this.$emit('save', this.data);
      this.edit = false;
    },
    cancelEdit() {
      this.edit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.playfare {
    font-family: "Playfair Display", serif;
}
</style>
